// src/apiUtils/apiCallbackDefaults.js
// Minimal defaults for API callbacks

/**
 * Default callback configurations for any API endpoint without custom config
 */
export const defaultCallbacks = {
    // Default behavior for any API endpoint
    afterResponse: {
      actions: [
        {
          action: 'sendNotification',
          config: {
            message: 'API call completed successfully',
            type: 'success'
          }
        }
      ]
    },
    onError: {
      actions: [
        {
          action: 'sendNotification',
          config: {
            message: 'API Error: {value}',
            type: 'error',
            extractPath: 'error.message'
          }
        }
      ]
    },
    onComplete: {
      actions: [
        {
          action: 'sendNotification',
          config: {
            message: 'Workflow completed successfully',
            type: 'success'
          }
        }
      ]
    }
  };
  
  /**
   * Shared callback patterns that components can reuse
   */
  export const sharedPatterns = {
    // Standard job tracking pattern
    jobTracking: {
      afterResponse: {
        actions: [
          {
            action: 'appendState',
            config: {
              state: 'starting',
              messageTemplate: {title: "appendState", value: "completed"},
              extractMapping: {
                error: 'data.error',
                progress_percent: 0
              }
            }
          },
          {
            action: 'updateSharedParams',
            config: {
              extractMapping: {
                error: 'data.error',
                // startTime: 'data.job.timestamp'
              }
            }
          },
          {
            action: 'uplynkCentralInitiator',
            configType: 'generic' // Component would override this with specific type
          }
        ]
      }
    },
    
    // Standard notification-only pattern
    notificationOnly: {
      afterResponse: {
        actions: [
          {
            action: 'sendNotification',
            config: {
              message: 'Operation completed successfully',
              type: 'success'
            }
          }
        ]
      }
    }
  };
  
  /**
   * Get default callback configuration for a specific callback type
   * @param {string} callbackType - Type of callback (afterResponse, onError, onComplete)
   * @returns {Object} Default configuration for that callback type
   */
  export const getDefaultCallbackConfig = (callbackType) => {
    return defaultCallbacks[callbackType] || null;
  };
  
  export default {
    defaultCallbacks,
    sharedPatterns,
    getDefaultCallbackConfig
  };